import {Container} from '@mantine/core'
import {createFileRoute} from '@tanstack/react-router'

import {requireAdminBeforeLoad} from '../../../auth/require-admin-before-load'
import {UsersPage} from '../../../users/users-page'

export const Route = createFileRoute('/_app/users/')({
    beforeLoad: requireAdminBeforeLoad,
    component: UsersRoute,
})

function UsersRoute() {
    return (
        <Container size="lg" py="xl">
            <UsersPage />
        </Container>
    )
}
